import EligibilityMessagePriority from "./EligibilityMessagePriority";

export default class EligibilityMessagePriorityWithId extends EligibilityMessagePriority {

	public id: string | null = null;
	
	public constructor() {
		super();
	}
};